<template>
    <div>
        <div v-if=(row.new) class="absolute">
            <span class="inline-flex items-center px-1 py-0.5 rounded text-xs font-medium bg-cyan-800 text-white">
                New
            </span>
        </div>   
        <div v-if="status" class="absolute pt-1 pl-1">
            <span class="">
                <XCircleIcon class="w-5 text-rose-700"/>
            </span>
        </div>                         

        <div type="button" class="group p-2 w-full flex border-gray-200 shadow-sm  text-left ">
            <div class="min-w-0 flex-1 flex items-center space-x-2">
                <span class="block flex-shrink-0">
                    <Avatar :avatar="row.avatar" size='xs' class="inline-block rounded-full" />                    
                </span>
                <span class="block min-w-0 flex-1">
                    <span class="block text-xs font-medium  truncate">{{ row.name }}</span>
                </span>
                <div v-if="row.roles && row.roles.name" class="pt-1 text-xs font-normal rounded-md text-gray-500 flex items-center gap-1" >
                    <div :class="(row.roles.color || 'bg-gray-500')" class="rounded-full h-2 w-2" :title="row.roles.name"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { XCircleIcon } from '@heroicons/vue/24/solid'

export default {

    name:"UserCardMicro",
    props: {
        row: {
            type: Object,
            required: true
        },
        status: {
            type: Boolean,
            default: false
        },
    },
    methods: {

       
    },
    components: {
        XCircleIcon,
    },
}
</script>